"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Text2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Alert = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Alert"));
var _PasswordStrengthBar = _interopRequireDefault(require("../PasswordStrengthBar"));
var _password = require("../../../../consts/password");
var _PasswordLabelTranslation = _interopRequireDefault(require("../PasswordLabelTranslation"));
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage, _Text;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PasswordValidationBox = _ref => {
  let {
    passwordStrength,
    showHint
  } = _ref;
  const {
    color,
    width,
    orbitTextType,
    label
  } = _password.CONFIGS[passwordStrength];
  const intl = (0, _reactIntl.useIntl)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      align: "center",
      mediumMobile: {
        justify: "between"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordStrengthBar.default, {
        color: color,
        width: width
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
        dataTest: "MagicLogin-PasswordValidationStrengthLabel",
        weight: "bold",
        type: orbitTextType,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordLabelTranslation.default, {
          label: label
        })
      })]
    }), passwordStrength === "WEAK" && showHint === true ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert.default, {
      type: "info",
      title: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.password_validation.hint_title"
      })),
      labelClose: intl.formatMessage({
        id: "orbit.button_close"
      }),
      children: _Text || (_Text = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.password_validation.tooltip_text"
        })
      }))
    }) : null]
  });
};
var _default = exports.default = PasswordValidationBox;